// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qHYTX","field":"styles_field__3Wzaa","fieldCol":"styles_fieldCol__12L4q","diffCol":"styles_diffCol__4AO6c","diff":"styles_diff__3BW2i"};